/**
 * Tenant labels are rendered verbatim, except that the client marks required fields with
 * trailing asterisks ("Email***"). We strip them for display and treat their presence as
 * "required" (see validation.systemFieldRequirement).
 */
export function stripRequiredMarker(label: string | null | undefined): { text: string; markedRequired: boolean } {
  const raw = (label ?? '').replace(/\s+/g, ' ').trim();
  const match = /^(.*?)\s*\*+$/.exec(raw);
  if (match && match[1] !== undefined && match[1].trim() !== '') {
    return { text: match[1].trim(), markedRequired: true };
  }
  return { text: raw, markedRequired: false };
}

export const DEFAULT_SYSTEM_LABELS: Record<string, string> = {
  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email',
  phone: 'Phone',
  address: 'Street address',
  apt_suite: 'Apt / Suite',
  city: 'City',
  state: 'State',
  zip: 'ZIP code',
  service: 'Service',
  service_date: 'Date & time',
  frequency: 'How often',
  discount_code: 'Discount code',
  credit_card_payment: 'Credit card',
  cash_payment: 'Cash',
  check_payment: 'Check',
};
